import React, { useEffect, useState } from 'react';
import { Loading } from '@b-design/fusion';
import Button from '@/components/Button';
import { history } from 'ice';
import $i18n from '@/i18n';
import { formatTime } from '@/utils';
import styles from './index.module.less';
import EmptyHeader from '@/components/EmptyHeader';
import { getQueryStringArgs } from '@/utils/url-parse';
import Requests from '@/services/request';
import NameIcon from '@/components/NameIcon';
import ColorTags from '@/components/ColorTags';
import { getSpaceStatus } from '@/utils/status';

const JoinSpace: React.FC = () => {
  const { invitationCode, spaceName, spaceId } = getQueryStringArgs();
  const [baseData, setBaseData] = useState<Record<string, any>>({})
  const [loading, setLoading] = useState(false)

  const queryBaseInfo = (params = { spaceId, invitationCode, currentPage: 1, pageSize: 10, type: 'APP_DEVELOPER' }) => {
    // if (!spaceId) {
    //   return;
    // };
    setLoading(true);
    Requests.get('/rest/intercnn/invitation/detail', { invitationCode }, { toRegisterIfNotLogin: true }, true).then((data) => {
      if (data) {
        setBaseData(data);
        setLoading(false);
      }
    }).catch((err) => {
       history?.push(`/error?reason=${err.errorCode || ''}`);
    });
  }

  useEffect(() => {
    queryBaseInfo()
  }, [])

  const toJoin =  async () => {
    const data = await Requests.post('/rest/intercnn/space/join', { spaceId, invitationCode });
    if (data) {
      history?.push(`/?spaceId=${spaceId || ''}`)
    }
  }

  return (
    <div className={styles.container}>
      <EmptyHeader />
      <div className={styles.content}>
        <Loading visible={loading}>
          <div className={styles.title}>
            {$i18n.get({ id: 'aopf.pages.joinSpace.title', dm: '加入空间' })}
          </div>
          <div className={styles.describe}>
            <span style={{ fontWeight: '700' }}>{baseData?.inviter}</span>
            {$i18n.get({ id: 'aopf.pages.joinSpace.describe', dm: '邀请您加入工作区。' })}
          </div>
          <div className={styles.detail}>
            {$i18n.get({ id: 'aopf.pages.joinSpace.detail', dm: '加入后，您可以与合作伙伴合作开发应用。' })}
          </div>
          {baseData?.spaceIcon ?
            <img src={baseData?.spaceIcon} className={styles.icon} /> :
            <NameIcon
              name={baseData?.spaceName}
              styles={{
                height: 40, width: 40, borderRadius: 4, margin: ' 0 auto', marginTop: 32, position: 'relative',
              }}
            />}
          <div className={styles.card}>
            <div className={styles.workspace}>{baseData?.spaceName || spaceName}</div>
            <ColorTags {...getSpaceStatus(baseData?.spaceStatus)} />

          </div>
          <div className={styles.times}>
            {$i18n.get({ id: 'aopf.pages.joinSpace.times', dm: '邀请有效期至' })}
            <span style={{ fontWeight: '700' }}>{formatTime(baseData?.validDate)}</span>
          </div>
          <div className={styles.please}>
            {$i18n.get({ id: 'aopf.pages.joinSpace.response', dm: '请尽快回复。' })}
          </div>
          <Button style={{ borderRadius: 4, width: 120, height: 40, marginTop: '48px' }} type="primary" onClick={toJoin}>
            {$i18n.get({ id: 'aopf.pages.joinSpace.joinNow', dm: '立即加入' })}
          </Button>
        </Loading>
      </div>
    </div>


  );
};

export default JoinSpace;